import React, { useEffect, useState } from "react";
import { consumeHandoffFromHash } from "../../../shared/utils/handoffClient";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
import "./handoffPage.scss";

/**
 * Receives a cross-origin auth handoff from the *other* app shell, writes
 * the bridged session into `localStorage`, and full-page-reloads to the
 * intended destination. The full reload (vs `history.push`) is deliberate:
 * it lets `App.tsx`'s boot-time `AUTHENTICATED` dispatch (which reads
 * `localStorage["auth"]` + `localStorage["user"]`) bootstrap the redux
 * store cleanly, avoiding any race against in-flight route guards on a
 * half-hydrated tree.
 *
 * Renders a minimal spinner; failure (no/expired/malformed fragment) shows
 * a brief message and bounces to `/auth/login`.
 */
const HandoffPage: React.FC = () => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const result = consumeHandoffFromHash();
    if (!result.ok) {
      setFailed(true);
      // Give the user a beat to read the message before bouncing.
      const tid = window.setTimeout(() => {
        window.location.replace(AppRoutes.LOGIN);
      }, 1200);
      return () => window.clearTimeout(tid);
    }
    window.location.replace(result.returnPath || AppRoutes.HOME);
  }, []);

  return (
    <div className="rl-handoff-page">
      <div className="rl-handoff-page__spinner" aria-hidden />
      <p className="rl-handoff-page__label">
        {failed ? "Session handoff failed. Redirecting…" : "Signing you in…"}
      </p>
    </div>
  );
};

export default HandoffPage;
